import React, { useState } from 'react';
import { ShoppingCartIcon, SearchIcon, MenuIcon, UserIcon, XIcon } from 'lucide-react';
import { useCart } from '../contexts/CartContext';
import { CartModal } from './CartModal';
export function Header() {
  const {
    cartCount
  } = useCart();
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  return <>
      <header className="bg-white border-b border-gray-200 sticky top-0 z-50 shadow-sm" data-id="element-88">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-89">
          <div className="flex items-center justify-between h-16" data-id="element-90">
            {/* Logo */}
            <div className="flex items-center" data-id="element-91">
              <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="lg:hidden mr-4 p-2 hover:bg-gray-100 rounded-md transition" data-id="element-92">
                {isMobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-93" /> : <MenuIcon className="w-6 h-6" data-id="element-94" />}
              </button>
              <h1 className="text-2xl font-bold text-red-600 cursor-pointer hover:text-red-700 transition" data-id="element-95">
                Buy Spot
              </h1>
            </div>
            {/* Desktop Navigation */}
            <nav className="hidden lg:flex space-x-8" data-id="element-96">
              <a href="#" className="text-gray-900 font-medium hover:text-red-600 transition-colors relative group" data-id="element-97">
                Shop
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-red-600 transition-all group-hover:w-full" data-id="element-98"></span>
              </a>
              <a href="#" className="text-gray-600 hover:text-red-600 transition-colors relative group" data-id="element-99">
                Categories
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-red-600 transition-all group-hover:w-full" data-id="element-100"></span>
              </a>
              <a href="#" className="text-gray-600 hover:text-red-600 transition-colors relative group" data-id="element-101">
                Deals
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-red-600 transition-all group-hover:w-full" data-id="element-102"></span>
              </a>
              <a href="#" className="text-gray-600 hover:text-red-600 transition-colors relative group" data-id="element-103">
                About
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-red-600 transition-all group-hover:w-full" data-id="element-104"></span>
              </a>
            </nav>
            {/* Right side actions */}
            <div className="flex items-center space-x-2 sm:space-x-4" data-id="element-105">
              <button className="p-2 hover:bg-gray-100 rounded-md transition-colors" data-id="element-106">
                <SearchIcon className="w-5 h-5 text-gray-600" data-id="element-107" />
              </button>
              <button className="p-2 hover:bg-gray-100 rounded-md transition-colors" data-id="element-108">
                <UserIcon className="w-5 h-5 text-gray-600" data-id="element-109" />
              </button>
              <button onClick={() => setIsCartOpen(true)} className="relative p-2 hover:bg-gray-100 rounded-md transition-colors" data-id="element-110">
                <ShoppingCartIcon className="w-5 h-5 text-gray-600" data-id="element-111" />
                {cartCount > 0 && <span className="absolute -top-1 -right-1 bg-red-600 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center font-medium animate-pulse" data-id="element-112">
                    {cartCount}
                  </span>}
              </button>
            </div>
          </div>
          {/* Mobile Menu */}
          {isMobileMenuOpen && <div className="lg:hidden py-4 border-t border-gray-200 animate-slideDown" data-id="element-113">
              <nav className="flex flex-col space-y-3" data-id="element-114">
                <a href="#" className="text-gray-900 font-medium hover:text-red-600 transition-colors py-2" data-id="element-115">
                  Shop
                </a>
                <a href="#" className="text-gray-600 hover:text-red-600 transition-colors py-2" data-id="element-116">
                  Categories
                </a>
                <a href="#" className="text-gray-600 hover:text-red-600 transition-colors py-2" data-id="element-117">
                  Deals
                </a>
                <a href="#" className="text-gray-600 hover:text-red-600 transition-colors py-2" data-id="element-118">
                  About
                </a>
              </nav>
            </div>}
        </div>
      </header>
      <CartModal isOpen={isCartOpen} onClose={() => setIsCartOpen(false)} data-id="element-119" />
    </>;
}